import React from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "../shared";

const StepperChart = ({ displayCondition = true }) => {
  const { t } = useTranslation();

  return (
    <>
      {displayCondition ? (
        <div className="chart-of-progress">
          <p className="in-progress">
            <Icon iconName="circle" />
            <span>{t("track.inProgress")}</span>
          </p>
          <p className="completed">
            <Icon iconName="circle" />
            <span>{t("track.completed")}</span>
          </p>
          <p className="on-pending mx-0">
            <Icon iconName="circle" />
            <span>{t("track.pending")}</span>
          </p>
        </div>
      ) : null}
    </>
  );
};

export default React.memo(StepperChart);
